import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import {
    BB_BETFEED_FILTER_BOX_BET_TYPE_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_FILTER_BOX_SELECTED_CSS_CLASS_NAME_IDENTIFIER,
    BB_BETFEED_FILTER_CSS_CLASS_BODY_FILTER_NAME,
    GTM_BETFEED_SPLIT_FIRST,
} from '../../constants';

export class BetTypeFilter extends React.Component {

    constructor(props) {
        super(props);
        this.handleToggleFilter = this.handleToggleFilter.bind(this);
    }

    static propTypes = {
        betType: PropTypes.object.isRequired,
        selected: PropTypes.object.isRequired,
        toggleFilter: PropTypes.func.isRequired,
        filterType: PropTypes.object.isRequired,
        gtmAttribute: PropTypes.string,
    };

    static defaultProps = {
        gtmAttribute: null,
    };

    handleToggleFilter(filter, id) {
        return () => {
            this.props.toggleFilter(filter, id);
        };
    }

    renderFilter(filter, filterKey, filterName) {
        const returnFilter = Object.keys(filter).map(type => {
            const filterType = filter[type];
            const filterTypeId = filterType.id;

            const className = `${BB_BETFEED_FILTER_BOX_BET_TYPE_CSS_CLASS_BLOCK_NAME}
                ${this.props.selected.id === filterTypeId ?
                ` ${BB_BETFEED_FILTER_BOX_SELECTED_CSS_CLASS_NAME_IDENTIFIER}` : ''}`;
            const gtmFilterType = filterType.name.split('.').splice(GTM_BETFEED_SPLIT_FIRST).join('').replace('_', '-');

            return <div
                key={filterTypeId}
                className={className}
                onClick={this.handleToggleFilter(filterKey, filterTypeId)}
                data-spectate-product={`${this.props.gtmAttribute}${gtmFilterType}`}>
                    <div className={BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME}>
                        <Trans>{filterType.name}</Trans>
                    </div>
            </div>;
        });

        const filterTitle = (
            <div key={filterKey} className={BB_BETFEED_FILTER_CSS_CLASS_BODY_FILTER_NAME}>
                <Trans>{filterName}</Trans>
            </div>
        );

        return [filterTitle, returnFilter];
    }

    render() {
        const { id, name } = this.props.filterType;

        return this.renderFilter(this.props.betType, id, name);
    }
}

export default BetTypeFilter;
